import React from 'react';
import { imageSet } from '../../../helper/Images';

const TileItem = ({ active, squareSrc, onClick }) => {
  return (
    <li
      onClick={onClick}
      className={`list-color-item ${active ? 'active' : ''}`}
    >
      <img
        className="img-responsive quiz-imgs"
        src={imageSet[squareSrc]}
        alt=""
      />
    </li>
  );
};

export default TileItem;
